export default "__VITE_ASSET__BR8hiV_p__"